import axios, { AxiosRequestConfig } from "axios";
import { ADMIN_API_BASE } from "./adminApiConfig";

const getWinners = async (date: string): Promise<any> => {
  try {
    const config: AxiosRequestConfig = {
      method: "GET",
      // url: `https://test-back.firebird.rs/api/ultra/winners`,
      url: `${ADMIN_API_BASE}/api/ultra/winners`,
      headers: {
        "Content-Type": "application/json",
      },
      params: {
        date,
      },
    };

    const response = await axios(config);
    const { data } = response;
    const { code } = data;

    if (code !== 200) {
      return [];
    }

    return data.data;
  } catch (error) {
    return [];
  }
};

export default getWinners;
